import { useAppSelector } from "../../../../store/reduxHooks";
import {
  SELECT_REQUEST_BANK_DOCUMENTS,
  SELECT_REQUEST_BANK_ID,
} from "../../../../store/selectors/requestAppSelector";
import React from "react";
import classes from "../style/BankInfom.module.css";
import {
  UI_ITOModuleDocumentsList,
  UI_ITOModuleSubTitle,
} from "../../../../UI_ITO/indexUI";

export const BankCommissionDocumentsInfoStatus = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const bankRate = data?.bank_rate ? data?.bank_rate : data?.bank?.base_rate;
  const info = {
    overstatement: data.overstatement ? +data.overstatement : 0,
    base_commission: +data.base_commission,
    bank_commission: data.overstatement
      ? +data.overstatement + +data.base_commission
      : data.base_commission,
  };

  const applicationBankId = Number(data.id);

  const documentsForSigning = useAppSelector(SELECT_REQUEST_BANK_DOCUMENTS);

  return (
    <>
      <h3>Информация</h3>

      <div className={classes.infoContainer}>
        <div className={classes.info}>
          <>
            <div className={classes.info_row_key}>Тариф банка</div>
            <div className={classes.info_row_value}>
              {info.base_commission} ₽
            </div>
          </>
        </div>

        <div className={classes.info}>
          <>
            <div className={classes.info_row_key}>Ставка</div>
            <div className={classes.info_row_value}>{bankRate} %</div>
          </>
        </div>

        <div className={classes.info}>
          <>
            <div className={classes.info_row_key}>Завышение</div>
            <div className={classes.info_row_value}>{info.overstatement} ₽</div>
          </>
        </div>

        <div className={classes.info}>
          <>
            <div className={classes.info_row_key}>Итоговая комиссия</div>
            <div className={classes.info_row_value}>
              {info.bank_commission} ₽
            </div>
          </>
        </div>
      </div>

      <>
        <UI_ITOModuleSubTitle
          className={classes.titleDocFromBank}
          title={"Документы от банка"}
        />
        <UI_ITOModuleDocumentsList
          docs={documentsForSigning}
          applicationBankId={applicationBankId}
        />
      </>
    </>
  );
};
